import { useEffect } from 'react';
import Home from '@/pages/Home';
import { HeroVideoBackground } from '@/components/HeroVideoBackground';

export default function HeroBackgroundSample() {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Plasmics | Hero Background Sample';
    return () => { document.title = prev; };
  }, []);
  return <Home heroBackground={<HeroVideoBackground />} />;
}
